import {
    CART_RECEIVE,
    CART_SHOW_INFO,
    CART_UPDATE_QUANTITY,
} from '../constants';

export const cart = (
    state = {
        quantity: 0,
        orderTotal: 0,
        showInfo: false,
        productQuantity: { articleNumber: null, quantity: 1 },
    },
    action
) => {
    switch (action.type) {
        case CART_RECEIVE:
        case CART_SHOW_INFO:
            return {
                ...state,
                ...action.payload,
            };
        case CART_UPDATE_QUANTITY:
            return {
                ...state,
                productQuantity: {
                    ...action.payload,
                },
            };
        default:
            return state;
    }
};
